/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AddressTypeService } from './services/address-type.service';
import { AgencyService } from './services/agency.service';
import { AirportService } from './services/airport.service';
import { ApplicationService } from './services/application.service';
import { ApplicationPolicyService } from './services/application-policy.service';
import { AuditHistoryActionTypeService } from './services/audit-history-action-type.service';
import { AuthenticationService } from './services/authentication.service';
import { BloodTypeService } from './services/blood-type.service';
import { CanNumberService } from './services/can-number.service';
import { CertificationTypeService } from './services/certification-type.service';
import { CommunicationDeviceTypeService } from './services/communication-device-type.service';
import { CourseService } from './services/course.service';
import { CoursesRequiredByService } from './services/courses-required-by.service';
import { CoursesTrackedService } from './services/courses-tracked.service';
import { CredentialingPerformanceReportService } from './services/credentialing-performance-report.service';
import { CredentialingStatusReportViewService } from './services/credentialing-status-report-view.service';
import { DeployabilityReportViewService } from './services/deployability-report-view.service';
import { DeploymentGroupService } from './services/deployment-group.service';
import { DeploymentRoleService } from './services/deployment-role.service';
import { DeploymentRoleGroupService } from './services/deployment-role-group.service';
import { DocumentTypeService } from './services/document-type.service';
import { DriversLicenseIdentificationTypeService } from './services/drivers-license-identification-type.service';
import { DriversLicenseTypeService } from './services/drivers-license-type.service';
import { EmrSyncService } from './services/emr-sync.service';
import { EmrUsersViewService } from './services/emr-users-view.service';
import { EventService } from './services/event.service';
import { EventAttendanceService } from './services/event-attendance.service';
import { EventCountViewService } from './services/event-count-view.service';
import { EventIncidentLogService } from './services/event-incident-log.service';
import { EventListViewService } from './services/event-list-view.service';
import { EventLocationService } from './services/event-location.service';
import { EventTypeService } from './services/event-type.service';
import { ExternalFitDataService } from './services/external-fit-data.service';
import { FinanceService } from './services/finance.service';
import { FitTestReportViewService } from './services/fit-test-report-view.service';
import { FitTestStatusService } from './services/fit-test-status.service';
import { FlexFieldDefinitionService } from './services/flex-field-definition.service';
import { FormService } from './services/form.service';
import { GenderTypeService } from './services/gender-type.service';
import { GfeTypeService } from './services/gfe-type.service';
import { HoursService } from './services/hours.service';
import { IcsPositionService } from './services/ics-position.service';
import { ImmunizationMethodService } from './services/immunization-method.service';
import { ImmunizationTestResultService } from './services/immunization-test-result.service';
import { ImmunizationTypeService } from './services/immunization-type.service';
import { ImmunizationTypeMethodService } from './services/immunization-type-method.service';
import { ImmunizationTypeSequenceService } from './services/immunization-type-sequence.service';
import { IncidentSectionService } from './services/incident-section.service';
import { IncidentTypeService } from './services/incident-type.service';
import { IprDetailService } from './services/ipr-detail.service';
import { IprRequestService } from './services/ipr-request.service';
import { IprStatusService } from './services/ipr-status.service';
import { IprStatusHistoryService } from './services/ipr-status-history.service';
import { LanguageService } from './services/language.service';
import { LanguageProficiencyService } from './services/language-proficiency.service';
import { LeadershipRoleService } from './services/leadership-role.service';
import { LicensingCredentialStatusService } from './services/licensing-credential-status.service';
import { LookupManagerService } from './services/lookup-manager.service';
import { MedicalClearanceStatusService } from './services/medical-clearance-status.service';
import { MultiReportService } from './services/multi-report.service';
import { NonDeployableCategoriesService } from './services/non-deployable-categories.service';
import { NonFundedTrainingRequestService } from './services/non-funded-training-request.service';
import { NoteTypeService } from './services/note-type.service';
import { NotificationService } from './services/notification.service';
import { NotificationApprovalService } from './services/notification-approval.service';
import { NotificationAttachmentService } from './services/notification-attachment.service';
import { NotificationHistoryService } from './services/notification-history.service';
import { NotificationMessageService } from './services/notification-message.service';
import { NotificationRegistrationService } from './services/notification-registration.service';
import { NotificationRoutingService } from './services/notification-routing.service';
import { NotificationSectionService } from './services/notification-section.service';
import { NotificationStatusService } from './services/notification-status.service';
import { OrganizationService } from './services/organization.service';
import { ParsControllerService } from './services/pars-controller.service';
import { ParsStatusService } from './services/pars-status.service';
import { PassportTypeService } from './services/passport-type.service';
import { PayPeriodService } from './services/pay-period.service';
import { PayRecCategoryService } from './services/pay-rec-category.service';
import { PermissionsService } from './services/permissions.service';
import { PhoneNumberTypeService } from './services/phone-number-type.service';
import { PolicyService } from './services/policy.service';
import { PolicyRoleService } from './services/policy-role.service';
import { PositionService } from './services/position.service';
import { PositionsRequiredByService } from './services/positions-required-by.service';
import { ProcessService } from './services/process.service';
import { ProcessStepService } from './services/process-step.service';
import { ProviderApplicationStatusService } from './services/provider-application-status.service';
import { ProviderCredentialLevelService } from './services/provider-credential-level.service';
import { ProviderInternalStatusService } from './services/provider-internal-status.service';
import { ProviderLeieResultsService } from './services/provider-leie-results.service';
import { ProviderLicenseStatusService } from './services/provider-license-status.service';
import { ProviderNpdbResultsService } from './services/provider-npdb-results.service';
import { ReasonTypeService } from './services/reason-type.service';
import { ReportCategoryService } from './services/report-category.service';
import { ReportFieldService } from './services/report-field.service';
import { ReportItemService } from './services/report-item.service';
import { RequiredByService } from './services/required-by.service';
import { ReserveTypeService } from './services/reserve-type.service';
import { ResignationReportService } from './services/resignation-report.service';
import { RespiratorTypeService } from './services/respirator-type.service';
import { ResponderService } from './services/responder.service';
import { ResponderAddressService } from './services/responder-address.service';
import { ResponderAirportService } from './services/responder-airport.service';
import { ResponderAuditHistoryService } from './services/responder-audit-history.service';
import { ResponderAvailabilityService } from './services/responder-availability.service';
import { ResponderBadgeService } from './services/responder-badge.service';
import { ResponderBadgeDocumentService } from './services/responder-badge-document.service';
import { ResponderBadgeTypeService } from './services/responder-badge-type.service';
import { ResponderBduRequestService } from './services/responder-bdu-request.service';
import { ResponderCertificationService } from './services/responder-certification.service';
import { ResponderCommunicationDeviceService } from './services/responder-communication-device.service';
import { ResponderCourseService } from './services/responder-course.service';
import { ResponderCourseNonCompliantService } from './services/responder-course-non-compliant.service';
import { ResponderCreditCardService } from './services/responder-credit-card.service';
import { ResponderCurrentAttendanceService } from './services/responder-current-attendance.service';
import { ResponderDocumentService } from './services/responder-document.service';
import { ResponderDriversLicenseService } from './services/responder-drivers-license.service';
import { ResponderEmailAddressService } from './services/responder-email-address.service';
import { ResponderEmergencyContactService } from './services/responder-emergency-contact.service';
import { ResponderExternalHrDataService } from './services/responder-external-hr-data.service';
import { ResponderFITTestService } from './services/responder-fittest.service';
import { ResponderGfeTypeService } from './services/responder-gfe-type.service';
import { ResponderGradeService } from './services/responder-grade.service';
import { ResponderHealthStatusService } from './services/responder-health-status.service';
import { ResponderImmunizationDocumentService } from './services/responder-immunization-document.service';
import { ResponderImmunizationTestService } from './services/responder-immunization-test.service';
import { ResponderLanguageService } from './services/responder-language.service';
import { ResponderLicenseService } from './services/responder-license.service';
import { ResponderLicenseDocumentService } from './services/responder-license-document.service';
import { ResponderLicenseTypeService } from './services/responder-license-type.service';
import { ResponderNonDeployableDetailService } from './services/responder-non-deployable-detail.service';
import { ResponderNonDeployableReasonService } from './services/responder-non-deployable-reason.service';
import { ResponderNoteService } from './services/responder-note.service';
import { ResponderPassportService } from './services/responder-passport.service';
import { ResponderPhoneService } from './services/responder-phone.service';
import { ResponderPositionService } from './services/responder-position.service';
import { ResponderProcessService } from './services/responder-process.service';
import { ResponderProcessStepService } from './services/responder-process-step.service';
import { ResponderProviderInformationService } from './services/responder-provider-information.service';
import { ResponderProviderInformationViewService } from './services/responder-provider-information-view.service';
import { ResponderProviderLicenseService } from './services/responder-provider-license.service';
import { ResponderReserveService } from './services/responder-reserve.service';
import { ResponderSelfServiceAddressService } from './services/responder-self-service-address.service';
import { ResponderSeriesService } from './services/responder-series.service';
import { ResponderSpecialtyService } from './services/responder-specialty.service';
import { ResponderStatusService } from './services/responder-status.service';
import { ResponderStepService } from './services/responder-step.service';
import { ResponderTeamService } from './services/responder-team.service';
import { ResponderTravelIdService } from './services/responder-travel-id.service';
import { ResponderTypeService } from './services/responder-type.service';
import { ResponderWorkCapacityService } from './services/responder-work-capacity.service';
import { ResponderWorkCapacityTypeService } from './services/responder-work-capacity-type.service';
import { RmsPolicyService } from './services/rms-policy.service';
import { RmsPolicyAuthorizationService } from './services/rms-policy-authorization.service';
import { RmsPolicyManagerSearchService } from './services/rms-policy-manager-search.service';
import { RmsPolicyRoleService } from './services/rms-policy-role.service';
import { RmsRoleService } from './services/rms-role.service';
import { RmsRoleManagerSearchService } from './services/rms-role-manager-search.service';
import { RmsRolePermissionService } from './services/rms-role-permission.service';
import { RmsUserOrganizationPolicyService } from './services/rms-user-organization-policy.service';
import { RmsUserPolicyService } from './services/rms-user-policy.service';
import { RoleService } from './services/role.service';
import { RolePermissionService } from './services/role-permission.service';
import { RoleReportService } from './services/role-report.service';
import { RosterService } from './services/roster.service';
import { RosterDetailService } from './services/roster-detail.service';
import { RosterDocumentService } from './services/roster-document.service';
import { RosterDocumentArchiveService } from './services/roster-document-archive.service';
import { RosterRosterTagService } from './services/roster-roster-tag.service';
import { RosterStatusService } from './services/roster-status.service';
import { RosterStatusHistoryService } from './services/roster-status-history.service';
import { RosterStatusLockService } from './services/roster-status-lock.service';
import { RosterSubTypeService } from './services/roster-sub-type.service';
import { RosterTagService } from './services/roster-tag.service';
import { RosterTemplateService } from './services/roster-template.service';
import { RosterTypeService } from './services/roster-type.service';
import { RosterTypeRoleGroupService } from './services/roster-type-role-group.service';
import { SecureStorageService } from './services/secure-storage.service';
import { SpecialtyReportViewService } from './services/specialty-report-view.service';
import { SpecialtyTypeService } from './services/specialty-type.service';
import { StaffingPositionService } from './services/staffing-position.service';
import { StaffingPositionMappingService } from './services/staffing-position-mapping.service';
import { StaffingSeatService } from './services/staffing-seat.service';
import { StateNameService } from './services/state-name.service';
import { TeamService } from './services/team.service';
import { TeamAddressService } from './services/team-address.service';
import { TeamLeadershipService } from './services/team-leadership.service';
import { TeamLevelService } from './services/team-level.service';
import { TeamMemberStatusService } from './services/team-member-status.service';
import { TeamRegionService } from './services/team-region.service';
import { TeamsCredentialingPerformanceReportService } from './services/teams-credentialing-performance-report.service';
import { TeamSpecialistService } from './services/team-specialist.service';
import { TeamTimesheetService } from './services/team-timesheet.service';
import { TeamTypeService } from './services/team-type.service';
import { TeamVehicleService } from './services/team-vehicle.service';
import { TemplateDetailService } from './services/template-detail.service';
import { TimesService } from './services/times.service';
import { TimesheetService } from './services/timesheet.service';
import { TimesheetActivitiesService } from './services/timesheet-activities.service';
import { TimesheetEventService } from './services/timesheet-event.service';
import { TimesheetJustificationsService } from './services/timesheet-justifications.service';
import { TimesheetStatusService } from './services/timesheet-status.service';
import { TimesheetStatusHistoryService } from './services/timesheet-status-history.service';
import { TimesheetTasksService } from './services/timesheet-tasks.service';
import { TimeZoneService } from './services/time-zone.service';
import { TravelIdTypeService } from './services/travel-id-type.service';
import { TravelRosterService } from './services/travel-roster.service';
import { TravelRosterDetailService } from './services/travel-roster-detail.service';
import { TravelRosterDetailStatusService } from './services/travel-roster-detail-status.service';
import { TravelStatusService } from './services/travel-status.service';
import { TravelTaStatusService } from './services/travel-ta-status.service';
import { TravelTypeService } from './services/travel-type.service';
import { TravelVehicleTypeService } from './services/travel-vehicle-type.service';
import { TravelVoucherStatusService } from './services/travel-voucher-status.service';
import { UserService } from './services/user.service';
import { UserGuideService } from './services/user-guide.service';
import { UserGuideCategoryService } from './services/user-guide-category.service';
import { UserPolicyService } from './services/user-policy.service';
import { UserPreferenceService } from './services/user-preference.service';
import { UserRoleService } from './services/user-role.service';
import { UserSettingsService } from './services/user-settings.service';
import { UserSignatureService } from './services/user-signature.service';
import { WaiverTypeService } from './services/waiver-type.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AddressTypeService,
    AgencyService,
    AirportService,
    ApplicationService,
    ApplicationPolicyService,
    AuditHistoryActionTypeService,
    AuthenticationService,
    BloodTypeService,
    CanNumberService,
    CertificationTypeService,
    CommunicationDeviceTypeService,
    CourseService,
    CoursesRequiredByService,
    CoursesTrackedService,
    CredentialingPerformanceReportService,
    CredentialingStatusReportViewService,
    DeployabilityReportViewService,
    DeploymentGroupService,
    DeploymentRoleService,
    DeploymentRoleGroupService,
    DocumentTypeService,
    DriversLicenseIdentificationTypeService,
    DriversLicenseTypeService,
    EmrSyncService,
    EmrUsersViewService,
    EventService,
    EventAttendanceService,
    EventCountViewService,
    EventIncidentLogService,
    EventListViewService,
    EventLocationService,
    EventTypeService,
    ExternalFitDataService,
    FinanceService,
    FitTestReportViewService,
    FitTestStatusService,
    FlexFieldDefinitionService,
    FormService,
    GenderTypeService,
    GfeTypeService,
    HoursService,
    IcsPositionService,
    ImmunizationMethodService,
    ImmunizationTestResultService,
    ImmunizationTypeService,
    ImmunizationTypeMethodService,
    ImmunizationTypeSequenceService,
    IncidentSectionService,
    IncidentTypeService,
    IprDetailService,
    IprRequestService,
    IprStatusService,
    IprStatusHistoryService,
    LanguageService,
    LanguageProficiencyService,
    LeadershipRoleService,
    LicensingCredentialStatusService,
    LookupManagerService,
    MedicalClearanceStatusService,
    MultiReportService,
    NonDeployableCategoriesService,
    NonFundedTrainingRequestService,
    NoteTypeService,
    NotificationService,
    NotificationApprovalService,
    NotificationAttachmentService,
    NotificationHistoryService,
    NotificationMessageService,
    NotificationRegistrationService,
    NotificationRoutingService,
    NotificationSectionService,
    NotificationStatusService,
    OrganizationService,
    ParsControllerService,
    ParsStatusService,
    PassportTypeService,
    PayPeriodService,
    PayRecCategoryService,
    PermissionsService,
    PhoneNumberTypeService,
    PolicyService,
    PolicyRoleService,
    PositionService,
    PositionsRequiredByService,
    ProcessService,
    ProcessStepService,
    ProviderApplicationStatusService,
    ProviderCredentialLevelService,
    ProviderInternalStatusService,
    ProviderLeieResultsService,
    ProviderLicenseStatusService,
    ProviderNpdbResultsService,
    ReasonTypeService,
    ReportCategoryService,
    ReportFieldService,
    ReportItemService,
    RequiredByService,
    ReserveTypeService,
    ResignationReportService,
    RespiratorTypeService,
    ResponderService,
    ResponderAddressService,
    ResponderAirportService,
    ResponderAuditHistoryService,
    ResponderAvailabilityService,
    ResponderBadgeService,
    ResponderBadgeDocumentService,
    ResponderBadgeTypeService,
    ResponderBduRequestService,
    ResponderCertificationService,
    ResponderCommunicationDeviceService,
    ResponderCourseService,
    ResponderCourseNonCompliantService,
    ResponderCreditCardService,
    ResponderCurrentAttendanceService,
    ResponderDocumentService,
    ResponderDriversLicenseService,
    ResponderEmailAddressService,
    ResponderEmergencyContactService,
    ResponderExternalHrDataService,
    ResponderFITTestService,
    ResponderGfeTypeService,
    ResponderGradeService,
    ResponderHealthStatusService,
    ResponderImmunizationDocumentService,
    ResponderImmunizationTestService,
    ResponderLanguageService,
    ResponderLicenseService,
    ResponderLicenseDocumentService,
    ResponderLicenseTypeService,
    ResponderNonDeployableDetailService,
    ResponderNonDeployableReasonService,
    ResponderNoteService,
    ResponderPassportService,
    ResponderPhoneService,
    ResponderPositionService,
    ResponderProcessService,
    ResponderProcessStepService,
    ResponderProviderInformationService,
    ResponderProviderInformationViewService,
    ResponderProviderLicenseService,
    ResponderReserveService,
    ResponderSelfServiceAddressService,
    ResponderSeriesService,
    ResponderSpecialtyService,
    ResponderStatusService,
    ResponderStepService,
    ResponderTeamService,
    ResponderTravelIdService,
    ResponderTypeService,
    ResponderWorkCapacityService,
    ResponderWorkCapacityTypeService,
    RmsPolicyService,
    RmsPolicyAuthorizationService,
    RmsPolicyManagerSearchService,
    RmsPolicyRoleService,
    RmsRoleService,
    RmsRoleManagerSearchService,
    RmsRolePermissionService,
    RmsUserOrganizationPolicyService,
    RmsUserPolicyService,
    RoleService,
    RolePermissionService,
    RoleReportService,
    RosterService,
    RosterDetailService,
    RosterDocumentService,
    RosterDocumentArchiveService,
    RosterRosterTagService,
    RosterStatusService,
    RosterStatusHistoryService,
    RosterStatusLockService,
    RosterSubTypeService,
    RosterTagService,
    RosterTemplateService,
    RosterTypeService,
    RosterTypeRoleGroupService,
    SecureStorageService,
    SpecialtyReportViewService,
    SpecialtyTypeService,
    StaffingPositionService,
    StaffingPositionMappingService,
    StaffingSeatService,
    StateNameService,
    TeamService,
    TeamAddressService,
    TeamLeadershipService,
    TeamLevelService,
    TeamMemberStatusService,
    TeamRegionService,
    TeamsCredentialingPerformanceReportService,
    TeamSpecialistService,
    TeamTimesheetService,
    TeamTypeService,
    TeamVehicleService,
    TemplateDetailService,
    TimesService,
    TimesheetService,
    TimesheetActivitiesService,
    TimesheetEventService,
    TimesheetJustificationsService,
    TimesheetStatusService,
    TimesheetStatusHistoryService,
    TimesheetTasksService,
    TimeZoneService,
    TravelIdTypeService,
    TravelRosterService,
    TravelRosterDetailService,
    TravelRosterDetailStatusService,
    TravelStatusService,
    TravelTaStatusService,
    TravelTypeService,
    TravelVehicleTypeService,
    TravelVoucherStatusService,
    UserService,
    UserGuideService,
    UserGuideCategoryService,
    UserPolicyService,
    UserPreferenceService,
    UserRoleService,
    UserSettingsService,
    UserSignatureService,
    WaiverTypeService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: { rootUrl: customParams.rootUrl }
        }
      ]
    }
  }
}
